<template>

  <div class="bill-info">
     <KTCodePreview v-bind:title="''"
      > <template v-slot:preview
        > <b-card
          no-body
          class="full-width"
          >
          <div>

            <div
              class="wizard wizard-4"
              id="kt_wizard_v4_bill"
              data-wizard-state="step-first"
              data-wizard-clickable="true"
            >
               <!--begin: Wizard Nav-->
              <div
                class="wizard-nav wizard-nav-bg"
                style="border-radius: 0px"
              >

                <div class="wizard-steps">
                   <!-- Thông tin -->
                  <div
                    class="wizard-step"
                    data-wizard-type="step"
                    data-wizard-state="current"
                  >

                    <div class="wizard-wrapper p-2">

                      <div class="wizard-label">

                        <div class="wizard-title">Thông tin</div>

                      </div>

                    </div>

                  </div>
                   <!-- Lịch sử -->
                  <div
                    class="wizard-step ml-1"
                    data-wizard-type="step"
                    v-show="mainModel.id"
                  >

                    <div class="wizard-wrapper p-2">

                      <div class="wizard-label">

                        <div class="wizard-title">Lịch sử</div>

                      </div>

                    </div>

                  </div>
                   <!-- Tệp đính kèm -->
                  <div
                    class="wizard-step ml-1"
                    data-wizard-type="step"
                    v-show="mainModel.id"
                  >

                    <div class="wizard-wrapper p-2">

                      <div class="wizard-label">

                        <div class="wizard-title">Tệp đính kèm</div>

                      </div>

                    </div>

                  </div>
                   <!-- Phiếu thu cũ -->
                  <div
                    class="wizard-step ml-1"
                    data-wizard-type="step"
                    v-show="mainModel.id"
                  >

                    <div class="wizard-wrapper p-2">

                      <div class="wizard-label">

                        <div class="wizard-title">Phiếu thu cũ</div>

                      </div>

                    </div>

                  </div>

                </div>

              </div>

              <div class="card card-custom card-shadowless rounded-top-0">
                 <b-skeleton-wrapper :loading="!renderComponent"
                  > <template #loading
                    > <BillInfoSkeleton :renderComponent="renderComponent" /> </template
                  >
                  <div class="card-body">

                    <div class="row">
                       <!-- Thông tin -->
                      <div class="col-xl-12">

                        <div
                          class="py-4 mb-5 full-width"
                          data-wizard-type="step-content"
                          data-wizard-state="current"
                        >
                           <b-row
                            class="col-md-12 mb-1 m-0 p-0"
                            v-if="isShowOrderNotCompleted"
                            >
                            <div
                              class="alert-header"
                              style="width: 100%"
                            >
                               Khách hàng này đang có đơn hàng chưa được hoàn tất
                              <ul
                                style="
                                  padding-left: 15px;
                                  line-height: 20px;
                                  margin-top: 5px;
                                  list-style: circle;
                                "
                              >

                                <li
                                  v-for="(order, i) in notCompleteOrders"
                                  :key="i"
                                >

                                  <div class="row">
                                     <span class="ml-2 mr-2">Đơn hàng</span>
                                    <div
                                      class="orderCode"
                                      @click="linkToOrder(order.id)"
                                      style="cursor: pointer"
                                    >
                                       <span
                                        v-text="order.id"
                                        class="text-primary"
                                      ></span
                                      >
                                    </div>

                                  </div>

                                </li>

                              </ul>

                            </div>
                             </b-row
                          > <b-row
                            class="col-md-12 mb-1 m-0 p-0"
                            v-if="mainModel.orderId"
                            >
                            <div
                              class="alert-header"
                              style="width: 100%"
                            >
                               Chuyển đơn hàng <span
                                class="text-primary"
                                style="cursor: pointer"
                                @click="linkToOrder(mainModel.orderId)"
                                >{{ mainModel.orderId }}</span
                              > sang hóa đơn bán lẻ .
                              <ul
                                style="
                                  padding-left: 15px;
                                  line-height: 20px;
                                  margin-top: 5px;
                                  list-style: circle;
                                "
                              >

                                <li v-show="mainModel.moneyPaid > 0">
                                   Số tiền đã đặt cọc: <span class="text-primary"
                                    > {{ convertPrice(mainModel.moneyPaid) }} </span
                                  >
                                </li>

                                <li v-show="mainModel.moneyTransfered > 0">
                                   Số tiền đã chuyển khoản: <span class="text-primary"
                                    > {{ convertPrice(mainModel.moneyTransfered) }} </span
                                  >
                                </li>

                                <li v-show="mainModel.moneyCredit > 0">
                                   Số tiền quẹt thẻ: <span class="text-primary"
                                    > {{ convertPrice(mainModel.moneyCredit) }} </span
                                  >
                                </li>

                                <li v-show="mainModel.moneyInstallment > 0">
                                   Số tiền đã trả góp: <span class="text-primary"
                                    > {{ convertPrice(mainModel.moneyInstallment) }} </span
                                  >
                                </li>

                                <li v-show="mainModel.customerShipFee > 0">
                                   Phí ship: <span class="text-primary"
                                    > {{ convertPrice(mainModel.customerShipFee) }} </span
                                  >
                                </li>

                              </ul>
                               Mã vận đơn: <span class="text-primary"
                                > {{ mainModel.codeShip }} </span
                              >
                            </div>
                             </b-row
                          >
                          <BillEInvoiceLockAlert :einvoice="mainModel.einvoice" />
                          <b-row
                            class="mb-2 mt-1 mx-0 p-0"
                            v-if="mainModel.billNumber"
                            > <b-col cols="12"
                              >
                              <div
                                class="d-flex align-items-center justify-content-start"
                                style="font-size: 1.125rem; font-weight: 600; color: #212121"
                              >
                                 <i
                                  class="fa fa-receipt text-warning mr-2"
                                  style="font-size: 1.3rem"
                                ></i
                                > <span
                                  > Mã hóa đơn: <span class="text-danger"
                                    >#{{ mainModel.billNumber }}</span
                                  > </span
                                > <span class="mx-3 text-muted">|</span> <span
                                  class="text-muted"
                                  style="font-weight: normal; font-size: 1rem"
                                  > Ngày tạo: {{ mainModel.billCreatedAt }} </span
                                >
                              </div>
                               </b-col
                            > </b-row
                          > <div class="row mx-0 bill-main-sections">
                            <div
                              class="col-12 col-md-9 mb-2 bill-main-sections__left"
                              :class="{ 'shipping-bill-readonly': isShippingBillRoute }"
                            >
                              <BillCustomer
                                :billData="mainModel"
                                v-on:onUpdate="onUpdateCustomer"
                                v-on:show-orders="showOrders"
                                v-if="renderComponent"
                              />
                              <BillProduct
                                v-if="renderComponent && !isWholesaleInvoice"
                                :billModel="mainModel"
                                :applyInstallmentProgram="applyInstallmentProgram"
                              />
                              <WholesaleBillProduct
                                v-if="renderComponent && isWholesaleInvoice"
                                :billModel="mainModel"
                              />
                              <BillEmployee
                                v-if="renderComponent"
                                :storeId="mainModel.storeId"
                                :billDataEmployeeInfo="mainModel.billEmployeeInfo"
                              />
                              <BillNote :billNote="mainModel.billNote" />
                            </div>
                            <div
                              class="col-12 col-md-3 mb-2 bill-main-sections__right"
                              :class="{ 'shipping-bill-readonly': isShippingBillRoute }"
                            >
                              <BillCheckoutForm
                                ref="bill-checkout-form"
                                :billModel="mainModel"
                                v-if="renderComponent"
                              />
                            </div>
                          </div>
                          <b-row class="col-md-12 mb-1 m-0 p-0"
                            > <b-container class="p-0"
                              >
                              <hr
                                class="hr-text"
                                data-content="Bút Toán"
                                style="font-weight: 600"
                              />
                               <b-row
                                > <b-col
                                  md="12"
                                  lg="12"
                                  sm="12"
                                  > <BillTransactions :billNumber="$route.query.id" /> </b-col
                                > </b-row
                              >
                              <div style="position: sticky; top: 200px">
                                 <b-row
                                  > <b-col
                                    > <template v-if="!isShippingBillRoute">
                                      <b-button
                                      style="font-weight: 600; width: 70px; margin-right: 10px"
                                      variant="primary"
                                      size="sm"
                                      @click="onSubmit('save')"
                                      :disabled="onSubmiting || !mainModel.editable"
                                      >Lưu</b-button
                                    > <b-button
                                      v-if="mainModel.billNumber"
                                      style="margin-right: 10px; font-weight: 600; width: 100px"
                                      variant="warning"
                                      size="sm"
                                      @click="onSubmit('save-print')"
                                      :disabled="onSubmiting || !mainModel.editable"
                                      > Lưu và in </b-button
                                    >
                                    </template>
                                    <router-link
                                      :to="billListBasePath"
                                      tag="button"
                                      > <b-button
                                        tabindex="16"
                                        style="font-weight: 600; width: 70px"
                                        variant="secondary"
                                        size="sm"
                                        >{{ isShippingBillRoute ? 'Đóng' : 'Hủy' }}</b-button
                                      > </router-link
                                    > </b-col
                                  > </b-row
                                >
                              </div>
                               </b-container
                            > </b-row
                          >
                        </div>

                      </div>
                       <!-- Lịch sử -->
                      <div class="col-xl-12">

                        <div
                          class="py-4 mb-5 full-width"
                          data-wizard-type="step-content"
                        >
                           <b-container class="bv-example-row"
                            > <b-table
                              :fields="historyFields"
                              :items="histories"
                              class="table-bordered table-hover col-md-6"
                              > <template v-slot:cell(updatedBy)="row"
                                >
                                <div class="d-flex flex-column">
                                   <strong>{{ row.item.createdByName }}</strong
                                  > <small class="text-muted">{{ row.item.createdAt }}</small
                                  >
                                </div>
                                 </template
                              > <template v-slot:cell(userAgent)="row"
                                >
                                <div class="d-flex flex-column">
                                   <span><strong>IP:</strong> {{ row.item.userIP }}</span
                                  > <span class="text-muted"
                                    > OS: {{ row.item.userAgent.osName }} </span
                                  > <span class="text-muted"
                                    > Browser: {{ row.item.userAgent.browserName }} </span
                                  >
                                </div>
                                 </template
                              > <template v-slot:cell(detail)="row"
                                >
                                <div
                                  class="orderCode"
                                  @click="openHistoryModal(row.item.id)"
                                  style="cursor: pointer; color: #3699ff; font-weight: 500"
                                >
                                   #{{ row.item.id }}
                                </div>
                                 </template
                              > <template v-slot:cell(action)="row"
                                > <b-badge
                                  :variant="
                                    row.item.action === 1
                                      ? 'warning'
                                      : row.item.action === 4
                                        ? 'info'
                                        : 'danger'
                                  "
                                  > {{
                                    row.item.action === 1
                                      ? 'Sửa hóa đơn'
                                      : row.item.action === 4
                                        ? 'Sửa ghi chú'
                                        : 'Xóa hóa đơn'
                                  }} </b-badge
                                > </template
                              > </b-table
                            > </b-container
                          >
                        </div>

                      </div>
                       <!-- Tệp đính kèm -->
                      <div class="col-xl-12">

                        <div
                          class="pb-5 full-width"
                          data-wizard-type="step-content"
                        >
                           <b-container class="bv-example-row"
                            > <b-row
                              >
                              <div class="w-100" v-if="!isShippingBillRoute">
                                 <upload-file
                                  :model-id="mainModel.billNumber"
                                  :model-name="'bills'"
                                  :max-files="10"
                                  :max-file-size="5 * 1024 * 1024"
                                />
                              </div>
                               </b-row
                            > </b-container
                          >
                        </div>

                      </div>
                       <!-- Phiếu thu cũ -->
                      <div
                        class="py-4 mb-5 full-width"
                        data-wizard-type="step-content"
                      ></div>

                    </div>

                  </div>
                   </b-skeleton-wrapper
                >
              </div>

            </div>

          </div>
           <BillHistoryModal
            :show="showHistoryModal"
            :history-id="selectedHistoryId"
            @update:show="showHistoryModal = $event"
            @open-modal="handleOpenModalFromUrl"
          /> </b-card
        > </template
      > </KTCodePreview
    >
  </div>

</template>

<script>
  import KTCodePreview from '@/view/content/CodeTab.vue'
  import KTWizard from '@/assets/js/components/wizard'
  import _uniq from 'lodash/uniq'
  import _isEmplty from 'lodash/isEmpty'
  import KTUtil from '@/assets/js/components/util'
  import ApiService from '@/core/services/api.service'
  import moment from 'moment'
  import apiCommonMixin from '@/view/mixins/api-common.mixins.js'
  import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module'
  import {
    PURGE_INTEREST_ZERO,
    PURGE_INSTALLMENT_PROGRAM,
    PURGE_INTEREST_SHINHAN,
    PURGE_INSTALLMENT_SHINHAN,
  } from '@/core/services/store/modules/payment/payment-installment.module'
  import { TIME_TRIGGER } from '@/utils/constants'
  import BillCheckoutForm from '@/view/components/bills/BillCheckoutForm.vue'
  import BillProduct from '@/view/components/bills/BillProduct.vue'
  import WholesaleBillProduct from '@/view/components/bills/WholesaleBillProduct.vue'
  // import CustomerInfo from '@/view/components/customers/CustomerInfo.vue';
  // import EmployeeInfo from '@/view/components/bills/EmployeeInfo.vue';
  import BillNote from '@/view/components/bills/BillNote.vue'
  import BillTransactions from '@/view/components/bills/BillTransactions.vue'
  import BillHistoryModal from '@/view/components/bills/BillHistoryModal.vue'
  import BillInfoSkeleton from '@/view/components/bills/BillInfoSkeleton.vue'
  import BillCustomer from '@/view/components/bills/BillCustomer.vue'
  import BillEmployee from '@/view/components/bills/BillEmployee.vue'
  import BillEInvoiceLockAlert from '@/view/components/bills/BillEInvoiceLockAlert.vue'
  import { makeToastFaile, makeToastSuccess, cloneDeep, convertPrice } from '@/utils/common'
  import { logBillPaymentDebug, getFirstPaymentRefId, getFirstPaymentRow } from '@/utils/billPaymentDebug'
  import { ITEM_TYPE, AMOUNT_TYPE, PRODUCT_TYPE, PAYMENT_TYPE, BILL_TYPE } from '@/utils/enum'
  import UploadFile from '@/view/modules/upload-v2/Upload.vue'
  //import Treeselect from '@riophae/vue-treeselect';
  //import '@riophae/vue-treeselect/dist/vue-treeselect.css';
  import sortListBillItem from '../../components/bills/helpers/sortListBillItem'
  import { nestAttachForPayload, resolveAttachLevel } from '../../components/bills/helpers/nestAttachItems'
  import {
    mergeWholesaleImeiBillRowsForDisplay,
    expandWholesaleImeiMainToPayloadRows,
  } from '@/view/components/bills/helpers/wholesaleImeiBillTransform'
  import {
    appendStackAmountsIfNeeded,
    hydrateSplitAmountsFromApi,
  } from '@/utils/voucherDiscountStack'
  import { normalizePromotionLabelsFromHydrate } from '@/utils/discountProgramDisplay'
  import { serializeExtraDiscountProgramIds } from '@/utils/discountProgramStack'
  import { ENABLE_MULTI_VOUCHER_RETAIL } from '@/constants/multiVoucherRetail'
  import {
    calculateRetailBillTotalAmount,
    hydrateLineVouchersFromApi,
    buildVouchersPayload,
    billHasMultiVoucherLines,
  } from '@/utils/billTotalAmount'
  import { hasVoucherOnLine } from '@/utils/voucherDiscountStack'

  export default {
    props: {
      billType: {
        type: Number,
        required: true,
      },
    },
    mixins: [apiCommonMixin],
    data() {
      return {
        mainModel: {
          id: null,
          billNumber: null,
          billType: this.billType,
          storeId: null,
          storeName: '',
          orderId: null,
          discountType: 1,
          discountAmount: 0,
          couponCode: '',
          editable: this.billType !== BILL_TYPE.SHIPPING,
          einvoice: {
            exists: false,
            workState: 'none',
            recordId: null,
            recordStatus: null,
            taxStatus: null,
            invoiceNo: null,
            pattern: null,
            serial: null,
            issuedAt: null,
            errorMessage: null,
          },
          billItems: [],
          customerModel: {
            customerId: null,
            customerName: '',
            customerMobile: '',
            customerEmail: '',
            customerAddress: '',
            customerCity: '',
            customerDistrict: '',
            customerWard: '',
            customerNote: '',
            customerPoint: 0,
            customerType: 1,
            customerStatus: 1,
            customerCreatedAt: '',
          },
          orderSourceId: null,
          employeeModel: {
            employeeId: null,
            employeeName: '',
            employeeMobile: '',
            employeeEmail: '',
          },
          billEmployeeInfo: {
            saleId: null,
            saleName: '',
            technicalId: null,
            technicalName: '',
            cashierId: null,
            cashierName: '',
            accessoryStaffId: null,
            accessoryStaffName: '',
            managerId: null,
            managerName: '',
            assistantId: null,
            assistantName: '',
            customerReceptionId: null,
            customerReceptionName: '',
            shipperId: null,
            shipperName: '',
          },
          billNote: {
            customerNote: '',
            saleNote: '',
            warrantyNote: '',
          },
          vatInvoice: {
            vatCompanyType: 1,
            taxCode: '',
            companyAddress: '',
            companyName: '',
            email: '',
          },
          paymentInfo: {
            //tiền mặt
            cashAmount: 0,
            cashAccountantName: '',
            cashAccountId: null,
            //chuyển khoản
            transferAmount: 0,
            transferAccountantName: '',
            transferAccountantId: null,
            transferReferenceCode: '',
            //quẹt thẻ
            creditAmount: 0,
            creditAccountantName: '',
            creditAccountantId: null,
            creditCode: '',
            creditCardNo: '',
            //phí quẹt thẻ
            creditCardFee: 0,
            creditFeeAccountantName: '',
            creditFeeAccountantId: null,
            payCreditFeeType: 1,
            //trả góp
            installedMoneyAmount: 0,
            installmentCode: '',
            installmentAccountName: '',
            installMoneyAccountId: null,
            customerIndentifyNo: '',
            installmentProgramMonthNo: 0,
            installmentProgramPrepayPercent: 0,
          },
          installments: [],
          credits: [],
          transfer: [],
          cash: [],
          refunds: [],
          customerShipFee: 0,
        },
        renderComponent: false,
        optionOrderSources: null,
        onSubmiting: false,
        historyFields: [
          {
            key: 'updatedBy',
            label: 'Người thao tác',
            thStyle: { textAlign: 'center', width: '20%' },
          },
          {
            key: 'action',
            label: 'Hành động',
            sortable: false,
            thStyle: {
              textAlign: 'center',
              color: 'rgb(24, 28, 50)',
              width: '30%',
            },
          },
          {
            key: 'userAgent',
            label: 'Thông tin thiết bị',
            sortable: false,
            thStyle: {
              textAlign: 'center',
              color: 'rgb(24, 28, 50)',
              width: '30%',
            },
          },
          {
            key: 'detail',
            label: 'Chi tiết',
            sortable: false,
            thStyle: { textAlign: 'center', color: 'rgb(24, 28, 50)' },
          },
        ],
        histories: [],
        showHistoryModal: false,
        selectedHistoryId: null,
        notCompleteOrders: [],
        invoiceType: null,
        bill_Type: BILL_TYPE,
      }
    },
    components: {
      KTCodePreview,
      BillProduct,
      WholesaleBillProduct,
      BillCheckoutForm,
      BillCustomer,
      // EmployeeInfo,
      BillEmployee,
      BillNote,
      // Treeselect,
      BillTransactions,
      BillHistoryModal,
      UploadFile,
      BillInfoSkeleton,
      BillEInvoiceLockAlert,
    },
    async mounted() {
      this.resetInstallmentSessionState()
      const billTypeName = this.billTypeDisplayName
      const billRoute = this.billListBasePath
      this.initialTab()
      this.mainModel.billNumber = this.$route.query.id ? this.$route.query.id : null
      const actionName = this.mainModel.billNumber
        ? this.isShippingBillRoute
          ? 'Chi tiết'
          : 'Cập nhật'
        : 'Thêm mới'
      this.$store.dispatch(SET_BREADCRUMB, [
        { title: `Hóa đơn ${billTypeName}`, route: billRoute },
        { title: `Danh sách hóa đơn ${billTypeName}`, route: billRoute },
        { title: `${actionName} hóa đơn ${billTypeName}` },
      ])
      this.mainModel.orderId = this.$route.query.fromOrderId ? this.$route.query.fromOrderId : null
      if (this.mainModel.billNumber) {
        this.getBillByBillNumber()
        this.fetchBillHistory()
        this.checkModalFromUrl()
      } else {
        if (this.mainModel.orderId) {
          this.getOrderById()
        } else {
          this.renderComponent = true
        }
      }
    },
    computed: {
      isWholesaleInvoice() {
        return this.billType === BILL_TYPE.WHOLESALE_INVOICE
      },
      hasEInvoiceLock() {
        const einvoice = this.mainModel && this.mainModel.einvoice
        return Boolean(einvoice && einvoice.workState && einvoice.workState !== 'none')
      },
      billListBasePath() {
        if (this.billType === BILL_TYPE.WHOLESALE_INVOICE) return '/wholesale-invoice'
        if (this.billType === BILL_TYPE.SHIPPING) return '/delivery-bills'
        return '/bills'
      },
      billListRouteName() {
        if (this.billType === BILL_TYPE.WHOLESALE_INVOICE) return 'list-wholesale-invoice'
        if (this.billType === BILL_TYPE.SHIPPING) return 'list-delivery-bill'
        return 'list-bill'
      },
      billTypeDisplayName() {
        if (this.billType === BILL_TYPE.WHOLESALE_INVOICE) return 'bán buôn'
        if (this.billType === BILL_TYPE.SHIPPING) return 'giao hàng'
        return 'bán lẻ'
      },
      isShippingBillRoute() {
        return this.billType === BILL_TYPE.SHIPPING
      },
      isShowOrderNotCompleted() {
        if (this.mainModel.id) {
          return false
        }
        if (_isEmplty(this.notCompleteOrders)) {
          return false
        }

        if (!this.mainModel.orderId) {
          return true
        }

        const fromOrderNotComplete = this.notCompleteOrders.find(
          (order) => order.id === Number(this.mainModel.orderId),
        )
        return fromOrderNotComplete ? false : true
      },
      applyInstallmentProgram() {
        return this.mainModel.billItems.some(
          (item) =>
            item.isInstallmentProgramProduct ||
            item.disabledByInstallmentProgram,
        )
      },
      useMultiVoucherRetailApi() {
        const billType = Number(this.mainModel.billType ?? this.billType)
        if (billType !== BILL_TYPE.RETAIL_INVOICE) {
          return false
        }
        if (ENABLE_MULTI_VOUCHER_RETAIL) {
          return true
        }
        return billHasMultiVoucherLines(this.mainModel.billItems)
      },
    },
    methods: {
      convertPrice,
      resetInstallmentSessionState() {
        this.$store.dispatch(PURGE_INTEREST_ZERO)
        this.$store.dispatch(PURGE_INSTALLMENT_PROGRAM)
        this.$store.dispatch(PURGE_INTEREST_SHINHAN)
        this.$store.dispatch(PURGE_INSTALLMENT_SHINHAN)
      },
      initialTab() {
        // Initialize form wizard
        const hashName = this.$route.hash ? this.$route.hash.split('#')[1] : ''

        this.hashName = hashName === 'attach' ? 'attach' : null

        const wizard = new KTWizard('kt_wizard_v4_bill', {
          startStep: hashName === 'attach' ? 3 : 1, // initial active step number
          clickableSteps: true, // allow step clicking
        })

        wizard.on('beforeNext', function (/*wizardObj*/) {})

        wizard.on('change', function (/*wizardObj*/) {
          setTimeout(() => {
            KTUtil.scrollTop()
          }, TIME_TRIGGER)
        })
      },
      onBack() {
        this.$router.push({
          name: this.billListRouteName,
        })
      },
      calcPaymentsAmount(items) {
        return items.reduce((result, item) => {
          const unMask = item.paymentAmount || 0
          return result + Number(unMask)
        }, 0)
      },
      linkToOrder: function (item) {
        const { href } = this.$router.resolve({
          name: 'edit-order',
          params: { id: item },
        })
        window.open(href, '_blank')
      },
      flattenFlexibleCombo(flexibleCombo) {
        const comboLines = flexibleCombo?.comboItems;
        if (!Array.isArray(comboLines)) {
          return [];
        }
        return comboLines.map((comboItem) => {
          return {
            id:
              comboItem.id != null && comboItem.id !== ''
                ? comboItem.id
                : null,
            productId: comboItem.productId,
            productPrice: comboItem.sellingPrice ?? comboItem.productPrice ?? 0,
            quantity: comboItem.quantity || 1,
            discountAmount: comboItem.discountAmount || 0,
            imeiCode: comboItem.imeiCode,
            productType: 1,
            billItemType: 1,
            accessoryGroupId: null,
            accessoryGroupCode: '',
            repurchasePrice: 0,
            isGiftTaken: true,
            note: '',
            gifts: [],
            attachs: [],
            discountType: AMOUNT_TYPE.MONEY,
            discountProgramId: null,
            issuedVat: true,
            flexibleComboId: flexibleCombo.flexibleComboId,
            flexibleComboItemId: comboItem.flexibleComboItemId,
          }
        })
      },
      convertBillItem(items) {
        return items.map((billItem) => {
          const promotionProgramId =
            billItem.promotionProgramId || billItem.accessoryGroupId || null
          return {
            id: billItem.id || null,
            productId: billItem.productId,
            productPrice: billItem.sellingPrice,
            quantity: billItem.quantity || 1,
            discountAmount: billItem.discountAmount || 0,
            imeiCode: billItem.imeiCode,
            billItemType: billItem.itemType,
            accessoryGroupId: billItem.accessoryGroupId || promotionProgramId,
            accessoryGroupCode:
              billItem.accessoryGroupCode || billItem.promotionProgramCode || '',
            promotionProgramId,
            promotionProgramCode: billItem.promotionProgramCode || '',
            attachLevel: resolveAttachLevel(billItem),
            repurchasePrice: 0,
            isGiftTaken: billItem.checked,
            note: billItem.note,
            gifts: [],
            attachs: [],
            discountType: billItem.discountType,
            discountProgramId: null,
            belongBillDetailId: billItem.belongBillDetailId,
            checked: billItem.checked,
          }
        })
      },
      isValidImeiCode(billItems) {
        return billItems.every((item) => {
          if (item.productType !== PRODUCT_TYPE.PRODUCT_IMEI) {
            return true
          }

          return item.imeiCode && item.imeiCode.trim()
        })
      },
      setBillItems() {
        const mainItems = this.mainModel.billItems.filter(
          (billItem) => billItem.itemType === ITEM_TYPE.MAIN && !billItem.flexibleComboId,
        )
        const flexibleComboBillItems = this.mainModel.billItems.filter(
          (billItem) => billItem.itemType === ITEM_TYPE.MAIN && billItem.flexibleComboId,
        )
        const giftItems = this.mainModel.billItems.filter(
          (item) => item.itemType === ITEM_TYPE.GIFT,
        )
        const attachItems = this.mainModel.billItems.filter(
          (item) => item.itemType === ITEM_TYPE.ATTACH,
        )

        const giftItemFormated = this.convertBillItem(giftItems)

        const mainProductItems = []
        mainItems.forEach((billItem) => {
          const gifts = giftItemFormated.filter(
            (giftItem) => giftItem.belongBillDetailId === billItem.id,
          )
          const attachs = nestAttachForPayload(
            attachItems,
            billItem.id,
            (row) => this.convertBillItem([row])[0],
            'belongBillDetailId',
          )

          const expanded = expandWholesaleImeiMainToPayloadRows(
            billItem,
            gifts,
            attachs,
            this.mainModel.billType,
          )
          if (expanded) {
            mainProductItems.push(...expanded)
            return
          }

          hydrateLineVouchersFromApi(billItem)
          const vouchersPayload = this.useMultiVoucherRetailApi
            ? buildVouchersPayload(billItem)
            : []

          const linePayload = appendStackAmountsIfNeeded(
            {
            id: billItem.id || null,
            productId: billItem.productId,
            productPrice: billItem.sellingPriceMask || billItem.sellingPrice || 0,
            quantity: billItem.quantity || 1,
            discountAmount: billItem.discountAmount || 0,
            imeiCode: billItem.imeiCode,
            billItemType: billItem.itemType,
            accessoryGroupId: billItem.accessoryGroupId,
            accessoryGroupCode: billItem.accessoryGroupCode,
            repurchasePrice: 0,
            isGiftTaken: billItem.checked,
            note: billItem.note,
            gifts: gifts,
            attachs: attachs,
            discountType: billItem.discountType,
            discountProgramId: billItem.discountProgramId,
            extraDiscountProgramIds: serializeExtraDiscountProgramIds(
              billItem.extraDiscountProgramIds,
              billItem.discountProgramId,
            ),
            issuedVat: billItem.isGetVat,
            merchantId: billItem.merchantId || 1,
            voucherId: billItem.voucherId || null,
            voucherDetailId: billItem.voucherDetailId || null,
            voucherCode: billItem.voucherCode || null,
            ...(this.useMultiVoucherRetailApi && hasVoucherOnLine(billItem)
              ? {
                  voucherAmount: Number(billItem.voucherAmount ?? 0),
                  discountProgramAmount: Number(billItem.discountProgramAmount ?? 0),
                }
              : {}),
            ...(this.useMultiVoucherRetailApi && vouchersPayload.length
              ? { vouchers: vouchersPayload }
              : {}),
            },
            billItem,
          )
          mainProductItems.push(linePayload)
        })
        let flexibleComboProductItems = []
        flexibleComboBillItems.forEach((flexibleComboBillItem) => {
          const flexibleComboTransformed = this.flattenFlexibleCombo(flexibleComboBillItem)
          flexibleComboProductItems = flexibleComboProductItems.concat(flexibleComboTransformed)
        })
        return mainProductItems.concat(flexibleComboProductItems)
      },
      setBillData() {
        logBillPaymentDebug('BillInfoV2', this.mainModel, 'setBillData')
        const billItems = this.setBillItems()
        const payload = {
          id: this.mainModel.id,
          billNumber: this.mainModel.billNumber || null,
          storeId: this.mainModel.storeId,
          //khach hang
          customerMobile: this.mainModel.customerModel.customerMobile.trim(),
          customerName: this.mainModel.customerModel.customerName.trim(),
          customerAddress: this.mainModel.customerModel.customerAddress,
          customerCity: this.mainModel.customerModel.customerCity,
          customerDistrict: this.mainModel.customerModel.customerDistrict,
          customerWard: this.mainModel.customerModel.customerWard,
          customerLastName: this.mainModel.customerModel.customerLastName,
          customerAppellation: this.mainModel.customerModel.customerAppellation,
          orderSourceId: this.mainModel.orderSourceId,
          //nhan vien
          saleId: this.mainModel.billEmployeeInfo.saleId,
          technicalId: this.mainModel.billEmployeeInfo.technicalId,
          accessoryStaffId: this.mainModel.billEmployeeInfo.accessoryStaffId,
          cashierId: this.mainModel.billEmployeeInfo.cashierId,
          managerId: this.mainModel.billEmployeeInfo.managerId,
          assistantId: this.mainModel.billEmployeeInfo.assistantId,
          customerReceptionId: this.mainModel.billEmployeeInfo.customerReceptionId,
          shipperId: this.mainModel.billEmployeeInfo.shipperId,
          //ghi chu
          customerNote: this.mainModel.billNote.customerNote,
          saleNote: this.mainModel.billNote.saleNote,
          warrantyNote: this.mainModel.billNote.warrantyNote,
          //chiet khau
          discountType: this.mainModel.discountType,
          discountAmount: this.mainModel.discountAmount || 0,
          billItems: billItems,
          orderId: this.mainModel.orderId,
          //hoa don do
          vatCompanyName: this.mainModel.customerModel.customerTaxName,
          vatCompanyAddress: this.mainModel.customerModel.customerTaxAddress,
          vatCompanyType: this.mainModel.customerModel.vatCompanyType,
          email: this.mainModel.customerModel.email,
          taxCode: this.mainModel.customerModel.customerTaxNo,
          //tieu diem
          pointUse: this.mainModel.subtractPoint || 0,
          isSubtractPointValidated: this.mainModel.isSubtractPointValidated,
          isCountPoint: this.mainModel.isCountPoint,
          //coupon
          isValidCouponCode: this.isValidCoupon,
          couponCode: this.mainModel.couponCode,
          // payment
          installments: this.mainModel.installments,
          credits: this.mainModel.credits,
          transfer: this.mainModel.transfer,
          cash: this.mainModel.cash,
          refunds: this.mainModel.refunds,
          //tien mat
          cashAmount: this.calcPaymentsAmount(this.mainModel.cash),
          cashAccountId: getFirstPaymentRefId(this.mainModel.cash),
          cashAccountCode: null,
          //chuyen khoan
          transferAmount: this.calcPaymentsAmount(this.mainModel.transfer),
          transferAccountID: getFirstPaymentRefId(this.mainModel.transfer),
          transferAccountCode: getFirstPaymentRow(this.mainModel.transfer)?.paymentCode,
          transferReferenceCode: getFirstPaymentRow(this.mainModel.transfer)?.paymentCode,
          //quet the
          creditAmount: this.calcPaymentsAmount(this.mainModel.credits),
          creditAccountId: getFirstPaymentRefId(this.mainModel.credits),
          creditAccountCode: getFirstPaymentRow(this.mainModel.credits)?.paymentCode,
          creditCode: getFirstPaymentRow(this.mainModel.credits)?.paymentCode,
          creditCardNo: getFirstPaymentRow(this.mainModel.credits)?.creditCardNo,
          //phi quet the
          otherFees: this.mainModel.paymentInfo.creditCardFee || 0,
          payCreditFeeType: this.mainModel.paymentInfo.payCreditFeeType,
          creditFeeAccountId: this.mainModel.paymentInfo.creditFeeAccountantId,
          creditFeeAcountCode: this.mainModel.paymentInfo.creditFeeAcountCode,
          //tra gop
          installedMoneyAmount: this.calcPaymentsAmount(this.mainModel.installments),
          installMoneyAccountId: getFirstPaymentRefId(this.mainModel.installments),
          installMoneyAccountCode: getFirstPaymentRow(this.mainModel.installments)?.paymentCode,
          customerIndentifyNo: getFirstPaymentRow(this.mainModel.installments)?.customerIndentifyNo,
          installMoneyCode: getFirstPaymentRow(this.mainModel.installments)?.installMoneyCode,
          billType: this.mainModel.billType,
        }
        if (this.useMultiVoucherRetailApi) {
          payload.billTotalAmount = calculateRetailBillTotalAmount(this.mainModel.billItems)
        }
        return payload
      },
      onCreateBill(payload) {
        const endpoint = this.useMultiVoucherRetailApi ? 'v2/bills' : 'v1/bills'
        ApiService.post(endpoint, payload)
          .then(({ data }) => {
            makeToastSuccess(data.message)
            this.onBack()
          })
          .catch((error) => {
            this.onSubmiting = false
            const message = error?.response?.data?.message || 'Lỗi!'
            makeToastFaile(message)
          })
      },
      printBill: async function () {
        const routeData = this.$router.resolve({
          name: 'print-bill',
          query: { id: this.mainModel.billNumber },
        })
        window.open(routeData.href, '_self')
      },
      onUpdateBill(payload, action) {
        const endpoint = this.useMultiVoucherRetailApi ? 'v2/bills/' : 'v1/bills/'
        ApiService.put(endpoint, payload)
          .then(({ data }) => {
            makeToastSuccess(data.message)
            if (action === 'save-print') {
              this.printBill()
            } else {
              this.onBack()
            }
          })
          .catch((error) => {
            this.onSubmiting = false
            const message = error?.response?.data?.message || 'Lỗi!'
            makeToastFaile(message)
          })
      },
      onSubmit(action) {
        if (this.isShippingBillRoute) {
          return
        }
        this.onSubmiting = true
        logBillPaymentDebug('BillInfoV2', this.mainModel, `onSubmit:${action}`)

        if (!this.mainModel.storeId) {
          this.onSubmiting = false
          return makeToastFaile('Vui lòng chọn cửa hàng!')
        }

        if (!this.mainModel.billItems.length) {
          this.onSubmiting = false
          return makeToastFaile('Bạn chưa chọn sản phẩm nào')
        }

        if (!this.isValidImeiCode(this.mainModel.billItems)) {
          this.onSubmiting = false
          return makeToastFaile('Vui lòng nhập mã IMEI cho sản phẩm IMEI')
        }

        // Validate payment
        if (this.$refs['bill-checkout-form']) {
          const isValid = this.$refs['bill-checkout-form'].validatePayment()
          if (!isValid) {
            this.onSubmiting = false
            return
          }
        }

        const billData = this.setBillData()
        if (this.mainModel.id) {
          this.onUpdateBill(billData, action)
        } else {
          this.onCreateBill(billData)
        }
      },
      onUpdateCustomer(customerInfo) {
        this.mainModel.customerModel = cloneDeep(customerInfo)
      },
      async loadOptionOrderSources() {
        const result = await this.fetchOrderSources()
        this.optionOrderSources = this.mapDataTreeSelect(result, ['id', 'name'])
      },
      mapDataTreeSelect(items = [], keys = []) {
        return items.map((element) => {
          return {
            id: element[keys[0]],
            label: element[keys[1]],
            shortName: element[keys[2]],
          }
        })
      },
      combineFlexibleCombo(billItems) {
        const flexibleComboIds = _uniq(
          billItems.map((flexibleComboBillItem) => flexibleComboBillItem.flexibleComboId),
        )
        return flexibleComboIds.map((flexibleComboId) => {
          const flexibleComboItems = billItems.filter(
            (billItem) => billItem.flexibleComboId === flexibleComboId,
          )
          let comboName = ''
          if (flexibleComboItems.length) {
            comboName = flexibleComboItems[0].flexibleComboName
          }
          const comboItems = flexibleComboItems.map((flexibleComboItem) => {
            return {
              id: flexibleComboItem.id,
              productCode: flexibleComboItem.productCode ? flexibleComboItem.productCode : '',
              productName: flexibleComboItem.productName ? flexibleComboItem.productName : '',
              quantity: flexibleComboItem.quantity,
              productId: flexibleComboItem.productId,
              productPrice: flexibleComboItem.productPrice ? flexibleComboItem.productPrice : 0,
              sellingPrice: flexibleComboItem.productPrice ? flexibleComboItem.productPrice : 0,
              productType: PRODUCT_TYPE.PRODUCT,
              discountAmount: flexibleComboItem.discountAmount,
              productComboPrice: 0,
              productComboRate: 0,
              productVatAmount: flexibleComboItem.productVatAmount,
              productNameVat: flexibleComboItem.productNameVat
                ? flexibleComboItem.productNameVat
                : '',
              listedPrice: flexibleComboItem.productPrice ? flexibleComboItem.productPrice : 0,
              flexibleComboItemId: flexibleComboItem.flexibleComboItemId ?? null,
            }
          })
          const flexibleComboPrice = comboItems.reduce((result, product) => {
            result += product.productPrice * product.quantity - product.discountAmount
            return result
          }, 0)
          return {
            id: flexibleComboId,
            productId: flexibleComboId,
            productName: comboName,
            productCode: '',
            productNameVat: '',
            productNote: '',
            productType: PRODUCT_TYPE.PRODUCT_COMBO,
            quantity: 1,
            productPrice: flexibleComboPrice,
            imeiCode: '',
            totalPrice: flexibleComboPrice,
            discount: 0,
            discountType: AMOUNT_TYPE.PERCENT,
            comboItems: comboItems,
            itemType: ITEM_TYPE.MAIN,
            checked: true,
            accessoryGroupId: null,
            accessoryGroupCode: '',
            repurchasePrice: 0,
            belongBillDetailId: null,
            note: '',
            listAccessoryPromotion: [],
            listProductPromotion: [],
            issuedVat: true,
            sellingPrice: flexibleComboPrice,
            sellingPriceMask: flexibleComboPrice,
            listedPrice: flexibleComboPrice,
            flexibleComboId: flexibleComboId,
          }
        })
      },
      getBillByBillNumber() {
        ApiService.get(`v1/bills/${this.mainModel.billNumber}`).then(async (response) => {
          const dataRes = response.data.data
          const {
            id,
            type,
            storeId,
            storeName,
            saleNote,
            customerNote,
            warrantyNote,
            customerId,
            discountAmount,
            discountType,
            orderSourceId,
            orderSourceName,
            customerShipFee,
            codeShip,
            cashAmount,
            cashAccountId,
            cashAccName,
            cashAccountCode,
            transferAmount,
            transferAccountId,
            transferAccName,
            transferAccountCode,
            transferReferenceCode,
            creditAmount,
            creditAccountId,
            creditAccName,
            creditAccountCode,
            creditCardNo,
            creditCode,
            otherFees,
            payCreditFeeType,
            creditFeeAcountId,
            creditFeeAccName,
            creditFeeAcountCode,
            installedMoneyAmount,
            installMoneyAccountId,
            installmentAccName,
            customerIndentifyNo,
            installMoneyCode,
            depositAmount,
            transferFromOrder,
            moneyCredit,
            moneyInstallment,
            pointToMoney,
            subtractPoint,
            couponCode,
            billItems,
            editable,
            isSubtractPointValidated,
            isCountPoint,
            payments,
            createdAt,
            // tradeIn,
            customerAppellation,
          } = dataRes
          // this.tradeIn = { ...tradeIn };
          this.mainModel.id = id
          this.invoiceType = type
          this.mainModel.storeId = storeId
          this.mainModel.storeName = storeName
          this.mainModel.billNote.warrantyNote = warrantyNote
          this.mainModel.billNote.saleNote = saleNote
          this.mainModel.billNote.customerNote = customerNote
          this.mainModel.customerModel.customerId = customerId
          this.mainModel.customerModel.customerMobile = dataRes.customerPhone
          this.mainModel.customerModel.customerAddress = dataRes.customerAddress
          this.mainModel.customerModel.customerName = dataRes.customerName
          this.mainModel.customerModel.customerCity = dataRes.customerCity
          this.mainModel.customerModel.customerWard = dataRes.customerWard
          this.mainModel.customerModel.customerDistrict = dataRes.customerDistrict
          this.mainModel.customerModel.totalPoint = dataRes.customerPoint
          this.mainModel.customerModel.customerAppellation = customerAppellation
          this.mainModel.orderSourceId = orderSourceId
          this.optionOrderSources = [
            {
              id: orderSourceId,
              label: orderSourceName || null,
            },
          ]
          this.mainModel.discountAmount = discountAmount ? discountAmount : 0
          this.mainModel.discountType = discountType
          this.mainModel.codeShip = codeShip
          this.mainModel.customerShipFee = customerShipFee ? customerShipFee : 0
          this.mainModel.billEmployeeInfo.saleId = dataRes.saleId
          this.mainModel.billEmployeeInfo.saleName = dataRes.saleName
          this.mainModel.billEmployeeInfo.technicalId = dataRes.technicalId
          this.mainModel.billEmployeeInfo.technicalName = dataRes.techName
          this.mainModel.billEmployeeInfo.cashierId = dataRes.cashierId
          this.mainModel.billEmployeeInfo.cashierName = dataRes.cashierName
          this.mainModel.billEmployeeInfo.managerId = dataRes.managerId
          this.mainModel.billEmployeeInfo.managerName = dataRes.managerName
          this.mainModel.billEmployeeInfo.assistantId = dataRes.assistantId
          this.mainModel.billEmployeeInfo.assistantName = dataRes.assistantName
          this.mainModel.billEmployeeInfo.customerReceptionId = dataRes.customerReceptionId
          this.mainModel.billEmployeeInfo.customerReceptionName = dataRes.customerReceptionName
          this.mainModel.billEmployeeInfo.accessoryStaffId = dataRes.accessoryStaffId
          this.mainModel.billEmployeeInfo.accessoryStaffName = dataRes.accessoryStaffName
          this.mainModel.billEmployeeInfo.shipperId = dataRes.shipperId
          this.mainModel.billEmployeeInfo.shipperName = dataRes.shipperName
          this.mainModel.paymentInfo.cashAmount = cashAmount
          this.mainModel.paymentInfo.cashAccountId = cashAccountId
          this.mainModel.paymentInfo.cashAccountantName = cashAccName
          this.mainModel.paymentInfo.cashAccountCode = cashAccountCode
          this.mainModel.paymentInfo.transferAmount = transferAmount
          this.mainModel.paymentInfo.transferAccountantId = transferAccountId
          this.mainModel.paymentInfo.transferAccountantName = transferAccName
          this.mainModel.paymentInfo.transferAccountCode = transferAccountCode
          this.mainModel.paymentInfo.transferReferenceCode = transferReferenceCode
          this.mainModel.paymentInfo.creditAmount = creditAmount
          this.mainModel.paymentInfo.creditAccountantId = creditAccountId
          this.mainModel.paymentInfo.creditAccountCode = creditAccountCode
          this.mainModel.paymentInfo.creditAccountantName = creditAccName
          this.mainModel.paymentInfo.creditCardNo = creditCode
          this.mainModel.paymentInfo.creditCardCode = creditCardNo
          this.mainModel.paymentInfo.creditCardFee = otherFees
          this.mainModel.paymentInfo.payCreditFeeType = payCreditFeeType
          this.mainModel.paymentInfo.creditFeeAccountantId = creditFeeAcountId
          this.mainModel.paymentInfo.creditFeeAcountCode = creditFeeAcountCode
          this.mainModel.paymentInfo.creditFeeAccountantName = creditFeeAccName
          this.mainModel.paymentInfo.installedMoneyAmount = installedMoneyAmount
          this.mainModel.paymentInfo.installMoneyAccountId = installMoneyAccountId
          this.mainModel.paymentInfo.installmentAccountName = installmentAccName
          this.mainModel.paymentInfo.customerIndentifyNo = customerIndentifyNo
          this.mainModel.paymentInfo.installmentCode = installMoneyCode
          this.mainModel.orderId = dataRes.orderId
          this.mainModel.moneyTransfered = transferFromOrder
          this.mainModel.moneyPaid = depositAmount
          this.mainModel.moneyCredit = moneyCredit
          this.mainModel.moneyInstallment = moneyInstallment
          this.mainModel.totalAmountPoint = pointToMoney
          this.mainModel.subtractPoint = subtractPoint
          this.prevSubtractPoint = subtractPoint
          this.mainModel.isSubtractPointValidated = isSubtractPointValidated
          this.mainModel.isCountPoint = isCountPoint
          this.mainModel.couponCode = couponCode
          this.prevCouponCode = couponCode
          this.mainModel.customerModel.customerTaxName = dataRes.companyName
          this.mainModel.customerModel.customerTaxAddress = dataRes.vatCompanyAddress
          this.mainModel.customerModel.vatCompanyType = dataRes.vatCompanyType
          this.mainModel.customerModel.email = dataRes.email
          this.mainModel.customerModel.customerTaxNo = dataRes.taxCode
          this.mainModel.customerModel.isExportInvoice = dataRes.taxCode ? true : false
          this.mainModel.billNote.customerNote = dataRes.customerNote
          this.mainModel.billNote.saleNote = dataRes.saleNote
          this.mainModel.billNote.warrantyNote = dataRes.warrantyNote
          if (dataRes.einvoice) {
            this.mainModel.einvoice = dataRes.einvoice
          }
          // BE đã fold einvoice-lock + permission BILL_ALLOW_EDIT_WHEN_EINVOICE_EXISTS vào `editable`.
          // FE chỉ giữ logic SHIPPING (BE chưa cover, không cho sửa hóa đơn giao hàng).
          this.mainModel.editable = this.billType === BILL_TYPE.SHIPPING ? false : editable
          this.mainModel.billCreatedAt = createdAt
          this.mainModel.installments = payments.filter(
            (item) => item.paymentType === PAYMENT_TYPE.INSTALLMENT,
          )
          this.mainModel.credits = payments.filter(
            (item) => item.paymentType === PAYMENT_TYPE.CREDIT,
          )
          this.mainModel.transfer = payments.filter(
            (item) => item.paymentType === PAYMENT_TYPE.TRANSFER,
          )
          this.mainModel.cash = payments.filter((item) => item.paymentType === PAYMENT_TYPE.CASH)
          this.mainModel.refunds = payments.filter(
            (item) => item.paymentType === PAYMENT_TYPE.REFUND,
          )
          const flexibleComboBillItems = billItems.filter((billItem) => billItem.flexibleComboId)
          const normalBillItems = billItems.filter((billItem) => !billItem.flexibleComboId)
          const flexibleComboItems = this.combineFlexibleCombo(flexibleComboBillItems)
          const mappedNormal = normalBillItems.map((billItem) => {
            const row = {
              id: billItem.id,
              productId: billItem.productId,
              productName: billItem.productName,
              productNameVat: billItem.productNameVat,
              barCode: billItem.barCode,
              productCode: billItem.productCode,
              imageUrl: billItem.imageUrl,
              sellingPrice: billItem.productPrice,
              sellingPriceMask: billItem.productPrice,
              productType: billItem.productType,
              quantity: billItem.quantity,
              imeiCode: billItem.imeiCode,
              totalPrice: billItem.quantity * billItem.productPrice - billItem.discountAmount,
              discountAmount:
                billItem.discountUnitAmount != null
                  ? billItem.discountUnitAmount
                  : billItem.discountAmount,
              comboItems: billItem.listProductInCombo,
              itemType: billItem.billItemType,
              repurchasePrice: billItem.repurchasePrice ? billItem.repurchasePrice : 0,
              accessoryGroupId: billItem.accessoryGroupId ? billItem.accessoryGroupId : '',
              accessoryGroupCode: billItem.accessoryGroupCode ? billItem.accessoryGroupCode : '',
              note: billItem.note,
              belongBillDetailId: billItem.belongBillDetailId,
              attachLevel: billItem.attachLevel || resolveAttachLevel(billItem),
              rootMainDetailId: billItem.rootMainDetailId || null,
              listAccessoryPromotion: billItem.listProductPromotion,
              quantityInStock: billItem.quantityInStock,
              storeId: storeId,
              discountType: parseInt(billItem.discountType),
              discountProgramId: billItem.discountProgramId,
              extraDiscountProgramIds: billItem.extraDiscountProgramIds || null,
              isGetVat: billItem.issuedVat === 1 ? true : false,
              disabledByInstallmentProgram: this.applyInstallmentProgram ? true : false,
              isInstallmentProgramProduct: this.applyInstallmentProgram ? true : false,
              listedPrice: billItem.listedPrice || 0,
              flexibleComboId: billItem.flexibleComboId || null,
              voucherId: billItem.voucherId || null,
              voucherDetailId: billItem.voucherDetailId || null,
              voucherCode: billItem.voucherCode || null,
              voucherCumluativeValues: billItem.cumluativeValues || [],
              promotionProgramCode: billItem.promotionProgramCode || '',
              promotionProgramName: billItem.promotionProgramName || '',
              promotionProgramId:
                billItem.promotionProgramId || billItem.accessoryGroupId || null,
            }
            hydrateSplitAmountsFromApi(row, billItem.discountProgramAmount, billItem.voucherAmount)
            if (Array.isArray(billItem.vouchers)) {
              row.vouchers = billItem.vouchers
            }
            hydrateLineVouchersFromApi(row)
            normalizePromotionLabelsFromHydrate(row, billItem)
            return row
          })
          this.mainModel.billItems = mergeWholesaleImeiBillRowsForDisplay(
            mappedNormal,
            this.billType,
          )
          this.mainModel.billItems = this.mainModel.billItems.concat(flexibleComboItems)
          this.mainModel.billItems = sortListBillItem(this.mainModel.billItems)
          setTimeout(() => {
            this.renderComponent = true
          }, TIME_TRIGGER)
        }).catch((error) => {
          const message = error?.response?.data?.message || 'Không thể tải hóa đơn'
          makeToastFaile(message)
          this.renderComponent = true
        })
      },
      getOrderById() {
        ApiService.query(`v1/orders/${this.mainModel.orderId}`).then((data) => {
          const {
            saleNote,
            customerNote,
            customerId,
            discountAmount,
            discountType,
            transferAmount,
            depositAmount,
            storeId,
            orderItems,
            orderSourceId,
            storeName,
            creditAmount,
            installedMoneyAmount,
            customerShipFee,
            warrantyNote,
            codeShip,
            saleStoreId,
            saleStoreName,
          } = data.data.data
          this.mainModel.billNote.warrantyNote = warrantyNote
          this.mainModel.storeId = storeId
          this.mainModel.storeName = storeName
          this.mainModel.billEmployeeInfo.saleId = saleStoreId
          this.mainModel.billEmployeeInfo.saleName = saleStoreName
          this.mainModel.billNote.saleNote = saleNote
          this.mainModel.billNote.customerNote = customerNote
          this.mainModel.customerModel.customerId = customerId
          this.mainModel.discountAmount = discountAmount ? discountAmount : 0
          this.mainModel.discountType = discountType
          this.searchStore = storeName
          this.mainModel.orderSourceId = orderSourceId
          this.mainModel.moneyTransfered = transferAmount
          this.mainModel.moneyPaid = depositAmount
          this.mainModel.moneyCredit = creditAmount
          this.mainModel.moneyInstallment = installedMoneyAmount
          this.mainModel.codeShip = codeShip
          this.mainModel.customerModel.customerMobile = data.data.data.customerMobile
          this.mainModel.customerModel.customerAddress = data.data.data.customerAddress
          this.mainModel.customerModel.customerName = data.data.data.customerName
          this.mainModel.customerModel.customerCity = data.data.data.customerCity
          this.mainModel.customerModel.customerWard = data.data.data.customerWard
          this.mainModel.customerModel.customerDistrict = data.data.data.customerDistrict
          this.mainModel.customerModel.customerTaxAddress = data.data.data.vatCompanyAddress
          this.mainModel.customerModel.customerTaxName = data.data.data.vatCompanyName
          this.mainModel.customerModel.customerTaxNo = data.data.data.taxCode
          this.mainModel.customerModel.email = data.data.data.email
          this.mainModel.couponCode = data.data.data.couponCode
          this.isValidCoupon = data.data.data.couponCode ? true : false
          this.mainModel.customerShipFee = customerShipFee ? customerShipFee : 0
          this.mainModel.customerModel.totalPoint = data.data.data.customerPoint
          this.mainModel.subtractPoint = data.data.data.subtractPoint
          this.mainModel.totalAmountPoint = data.data.data.subtractPointAmount
          this.mainModel.isSubtractPointValidated =
            data.data.data.subtractPointAmount > 0 ? true : false
          this.mainModel.billItems = orderItems.map((orderItem) => {
            return {
              id: orderItem.id,
              productId: orderItem.productId,
              barCode: orderItem.productBarCode,
              productName: orderItem.productName,
              productCode: orderItem.productCode,
              imageUrl: orderItem.imageUrl,
              productNameVat: orderItem.productNameVat,
              productType: orderItem.productType,
              sellingPrice: orderItem.productPrice,
              sellingPriceMask: orderItem.productPrice,
              imeiCode: orderItem.imeiCode,
              quantity: orderItem.quantity,
              totalPrice: orderItem.totalAmount,
              discountAmount:
                orderItem.orderItemType === AMOUNT_TYPE.MONEY ? orderItem.discountAmount : 0,
              discountType: AMOUNT_TYPE.MONEY,
              quantityInStock: orderItem.quantityInStock,
              comboItems:
                orderItem.comboItems ||
                orderItem.productInCombos ||
                orderItem.listProductInCombo ||
                [],
              flexibleComboId: orderItem.flexibleComboId ?? null,
              storeId: storeId,
              deleted: orderItem.deleted,
              itemType: orderItem.orderItemType,
              repurchasePrice: orderItem.repurchasePrice ? orderItem.repurchasePrice : 0,
              checked: true,
              listAccessoryBonus: [],
              note: orderItem.note ? orderItem.note : '',
              listAccessoryPromotion: orderItem.listAccessoryPromotion
                ? orderItem.listAccessoryPromotion
                : [],
              belongBillDetailId: orderItem.belongOrderDetailId,
              attachLevel: orderItem.attachLevel || resolveAttachLevel(orderItem),
              promotionProgramCode: orderItem.promotionProgramCode || '',
              promotionProgramId:
                orderItem.promotionProgramId || orderItem.accessoryGroupId || null,
              accessoryGroupId: orderItem.accessoryGroupId || null,
              accessoryGroupCode: orderItem.accessoryGroupCode || '',
              isGetVat: false,
            }
          })
          this.mainModel.billItems = sortListBillItem(this.mainModel.billItems)
          this.renderComponent = true
        })
      },
      openHistoryModal(historyId) {
        this.selectedHistoryId = historyId
        this.showHistoryModal = true
      },
      handleOpenModalFromUrl(historyId) {
        this.selectedHistoryId = historyId
        this.showHistoryModal = true
      },
      checkModalFromUrl() {
        const urlParams = new URLSearchParams(window.location.search)
        const modal = urlParams.get('modal')
        const historyId = urlParams.get('id')

        if (modal === 'bill-history' && historyId) {
          this.openHistoryModal(historyId)
        }
      },
      fetchBillHistory: async function () {
        const params = {
          //  loại hóa đơn
          type: 2,
        }
        await ApiService.query('/v1/histories/getByReferenceId/' + this.mainModel.billNumber, {
          params,
        }).then((res) => {
          const resData = res.data.data || []
          this.histories = resData.map((data) => {
            return {
              id: data.id,
              type: data.type,
              referenceId: data.referenceId,
              action: data.action,
              originalValue: data.originalValue,
              newValue: data.newValue,
              updatedBy: data.updatedBy,
              userAgent: data.userAgent,
              userIP: data.userIP,
              createdByName: data.createdByName,
              createdAt: moment(String(data.createdAt)).format('DD/MM/YYYY HH:mm'),
              updatedAt: moment(data.updatedAt).format('DD/MM HH:mm'),
            }
          })
        })
      },
      showOrders(notCompleteOrders) {
        this.notCompleteOrders = notCompleteOrders
      },
    },
  }
</script>

<style lang="scss">
  .shipping-bill-readonly {
    pointer-events: none;
    user-select: none;
  }

  .wizard.wizard-4 .wizard-nav .wizard-steps .wizard-step {
    flex: 0 0 calc(15% - 0.25rem);
  }

  @media (max-width: 1399.98px) {
    .wizard.wizard-4 .wizard-nav .wizard-steps .wizard-step {
      flex: 0 0 calc(17% - 0.25rem);
    }
  }

  .wizard-nav-bg {
    background-color: #f7f7f7;
    border-radius: 5px 5px 0px 0px;
  }

  .alert-header {
    position: relative;
    padding: 0.75rem 1.25rem;
    margin-bottom: 1rem;
    border: 1px solid transparent;
    border-radius: 0.25rem;
    color: #856404;
    background-color: #fff3cd;
    border-color: #ffeeba;
  }
  .box {
    background: black;
    border-radius: 4px;
    padding-bottom: 100%;
  }
  .headerTable {
    color: rgb(24, 28, 50);
    text-align: center;
  }

  .form-group label {
    font-weight: 500;
  }

  // UI Feedback
  .form-group {
    margin-bottom: 0.75rem;
  }
  .form-group label {
    margin-bottom: 0.25rem;
  }
  .p {
    margin-bottom: 0.25rem;
  }

  .textExcessCash {
    font-weight: 500;
    color: rgba(71, 71, 255, 0.87);
  }
  .row-center-vertical {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .textPoint {
    font-size: 14px;
    font-weight: 500;
  }
  .textFinal {
    font-weight: 500;
    color: brown;
  }
  .textTitlePayment {
    font-weight: 500;
    font-size: 14px;
  }

  .textPayment {
    font-size: 16px;
    font-weight: 500;
    color: brown;
  }

  .no-side {
    padding-left: 0px;
    padding-right: 0px;
  }
  .dropdown-custom {
    .btn-sm,
    .btn-group-sm > .btn {
      padding: 1px 2px;
      background-color: transparent;
      border: none;
      border-radius: 3px;
    }
  }

  .bill-main-sections {
    align-items: stretch;
  }

  .bill-main-sections__left,
  .bill-main-sections__right {
    display: flex;
    flex-direction: column;
  }

  .bill-main-sections__left .bill-product-table,
  .bill-main-sections__right .bill-checkout-form {
    height: 100%;
  }

  .bill-main-sections__right .bill-checkout-form {
    margin-top: 8px;
  }
</style>

<style lang="scss">
  @import '@/assets/sass/pages/wizard/wizard-4.scss';
</style>

<style lang="scss">
  .upload-file {
  table {
    table-layout: fixed;
  }
  .dropbox {
    margin: auto;
    width: 70%;
    background: #f8f8f8;
    border-radius: 20px;
    color: dimgray;
    padding: 10px 10px;
    min-height: 200px;
    position: relative;
    cursor: pointer;
  }

  .input-file {
    opacity: 0; /* invisible but it's there! */
    left: 0px;
    width: 100%;
    height: 200px;
    position: absolute;
    cursor: pointer;
  }

  .dropbox:hover {
    background: #e8f5e9;
  }

  .dropbox p {
    font-size: 1.2em;
    text-align: center;
    padding: 50px 0;
  }
  .img-container {
    position: relative;
    display: inline-block;
    width: 80px;
    margin: 0px 10px;
  }
  .preview-img {
    max-width: 80px;
    padding: 10px;
    object-fit: contain;
    border: 1px solid #eeecff;
    border-radius: 5px;
  }
  .preview-img-container {
    border: 2px dashed #eeecff;
    padding: 2rem 1rem;
  }

  .preview-box {
    display: inline-block;
  }
  .close {
    position: absolute;
    top: 0px;
    right: 0px;
    width: 15px;
  }
  .remove {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 15px;
  }
  .cancel {
    color: #545454;
    text-decoration: none;
  }
}
</style>

